import React, { useEffect } from 'react'
import CustomerImportWorker from './CustomerImport'
import ImportHelper from './ImportHelper'
import useCompanyConfig from '../../hooks/api/useCompanyConfig'
import { CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const CustomerImport = () => {
  const { companyConfig, isLoading } = useCompanyConfig()

  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading) return

    // if (companyConfig.hasCompletedBulkImport) navigate('/settings')
  }, [companyConfig, isLoading])

  if (isLoading) return <CircularProgress />

  return (
    <>
      <ImportHelper />
      <CustomerImportWorker />
    </>
  )
}

export default CustomerImport
